// frontend/modules/customer-category/views/CustomerCategoryDetailView.tsx
import React, { useEffect, useRef } from 'react';
import { Card, Typography, Button, Spin } from 'antd';
import { ArrowLeftOutlined, EditOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useTheme } from '@/components/common/ThemeProvider';
import CustomerCategoryPageForm from '../components/CustomerCategoryPageForm';
import { useCustomerCategories } from '../hooks/useCustomerCategories';

const { Title } = Typography;

const CustomerCategoryDetailView: React.FC = () => {
    const { dark } = useTheme();
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const { 
        activeCategory, 
        isLoading, 
        fetchCategoryById 
    } = useCustomerCategories();

    // Use ref to store the latest fetchCategoryById function to avoid dependency issues
    const fetchCategoryByIdRef = useRef(fetchCategoryById);
    fetchCategoryByIdRef.current = fetchCategoryById;

    useEffect(() => {
        if (id) {
            fetchCategoryByIdRef.current(parseInt(id));
        }
    }, [id]); // Only depend on id, use ref for function call

    const handleEdit = () => {
        navigate(`/admin/general-config/customer-categories/${id}/edit`);
    };

    const handleBack = () => {
        navigate('/admin/general-config/customer-categories');
    };

    if (isLoading || !activeCategory) {
        return (
            <div className="flex justify-center items-center h-64">
                <Spin size="large" />
            </div>
        );
    }

    return (
        <div className="space-y-6">
            <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                    <Button
                        icon={<ArrowLeftOutlined />}
                        onClick={handleBack}
                        type="text"
                    >
                        Back to Categories
                    </Button>
                    <Title level={2} className={`mb-0 ${dark ? 'text-white' : ''}`}>
                        Customer Category: {activeCategory.name}
                    </Title>
                </div>
                <Button
                    type="primary"
                    icon={<EditOutlined />}
                    onClick={handleEdit}
                >
                    Edit Category
                </Button>
            </div>

            <Card className={dark ? 'bg-gray-800' : ''}>
                <CustomerCategoryPageForm
                    mode="view"
                    initialData={activeCategory}
                    onSubmit={() => {}}
                    onCancel={handleBack}
                />
            </Card>
        </div>
    );
};

export default CustomerCategoryDetailView;
